import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MainService } from '../mainservices.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MainserviceService } from '../mainservice.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Globle } from 'src/assets/globle';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mainservicelist',
  templateUrl: './mainservicelist.component.html',
  styleUrls: ['./mainservicelist.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
  }
})
export class MainservicelistComponent implements OnInit {

  mainServiceList: MainService[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', 'imgUrl', "edit", "delete"];
  dataSource!: MatTableDataSource<MainService>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  mainService: MainService = {} as MainService;
  statusList: { id: boolean, name: string }[] = [];
  selectedStatus: boolean = true;
  imagPath: any;
  pageSize = 100;

  constructor(private service: MainserviceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globle: Globle,
    private translate: TranslateService) { }

  ngOnInit() {

    this.statusList = [{ id: true, name: this.translate.instant("active") },
    { id: false, name: this.translate.instant("notActive") }];
    this.selectedStatus = true;
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedStatus).subscribe(data => {
      this.mainServiceList = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.mainServiceList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/services/mainserviceform']);
  }

  edit(id: number) {
    this.router.navigate(['./master/services/mainserviceform/' + id]);
  }

  onDelete(id: number) {
    this.mainService.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.mainService.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.get();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.get();
  }

}
